(async () => {
  import('./bootstrap')
})();